import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.liveCasino,
  authRequired: false,
  gameListUrl: `vivogaming/game_list`,
  sessionUrlData: {
    url: `vivogaming/game/link`,
    method: QueryTypes.GET,
    getBody: params => ({
      table_id: params.id,
      lang: shortLanguages[params.lang as keyof typeof shortLanguages],
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
    converter: converter.convertGameUrl,
  },
  converter,
};
